export const content = {
  steps: [
    ['Schritt 1', 'Standort &', 'Lage'],
    ['Schritt 2', 'Gebäude-', 'details'],
    ['Schritt 3', 'Dachziegel &', 'Dachsteine'],
    ['Schritt 4', 'Sicherungs-', 'angaben'],
    ['Schritt 5', 'Ergebnis-', 'übersicht'],
  ],
}
